import i18n from "i18next";
import {call, put, takeLatest} from "redux-saga/effects";
import {cToast} from "helpers";
import { toolsActions } from './data';
import toolService from './api';


function* toGeoCode({payload}){
  const{
    excel_file,
  }=payload;
  try{
    const fData = new FormData();
    fData.append("excel_file", excel_file.binaryFile);
    const data = yield call(toolService.convertToGeoCode,fData);
    yield put(toolsActions.changeIntoGeocodeSuccess(data));
  }catch (err) {
    yield put(toolsActions.changeIntoGeocodeFailure(err));
    yield cToast({msg: i18n.t("Something went wrong"),variant:'error'});
  }
}

function* getNearbyScreens({payload}){
  const{
    excel_file,
    countValue,
    type,
  }=payload;
  try{
    const fData = new FormData();
    fData.append("excel_file", excel_file.binaryFile);
    const data = yield call(toolService.generateNearbyScreens, {fData, countValue, type});
    yield put(toolsActions.getNearbyScreensSuccess(data));
  }catch (err) {
    yield put(toolsActions.getNearbyScreensFailure(err));
    yield cToast({msg: i18n.t("Something went wrong"),variant:'error'});
  }
}

export default function* toolsSaga(){
  yield takeLatest(toolsActions.changeIntoGeocode.type, toGeoCode);
  yield takeLatest(toolsActions.getNearbyScreens.type, getNearbyScreens);
}